import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useIsAuthenticated, useAuthUser } from 'react-auth-kit';
import { hasAccessToRoute, getAllowedRoutes } from '../../config/roleConfig';

const ProtectedRouteBuiltIn = ({ component: Component, ...rest }) => {
    const isAuthenticated = useIsAuthenticated();
    const authUser = useAuthUser();

    return (
        <Route
            {...rest}
            render={(props) => {
                if (!isAuthenticated()) {
                    return <Redirect to="/login" />;
                }

                const user = authUser();
                const currentPath = props.location.pathname;

                if (
                    currentPath === '/company-settings' ||
                    currentPath === '/company-settings/'
                ) {
                    if (!user?.is_company_admin) {
                        const allowedRoutes = getAllowedRoutes(user);
                        const defaultRoute = allowedRoutes.length > 0 ? allowedRoutes[0] : '/login';
                        return <Redirect to={defaultRoute} />;
                    }
                }

                // Check if user has access to this route based on their roles
                if (!hasAccessToRoute(user, currentPath)) {
                    console.warn(`Access denied to ${currentPath} for user:`, user);

                    // Get the first allowed route for this user
                    const allowedRoutes = getAllowedRoutes(user);
                    const defaultRoute = allowedRoutes.length > 0 ? allowedRoutes[0] : '/login';

                    // Prevent infinite redirect loop
                    if (defaultRoute === currentPath || defaultRoute === currentPath + '/') {
                        console.error('Redirect loop detected, sending to login');
                        return <Redirect to="/login" />;
                    }

                    return <Redirect to={defaultRoute} />;
                }

                return <Component {...props} />;
            }}
        />
    );
};

export default ProtectedRouteBuiltIn;
